module.exports = __webpack_public_path__ + "img/spritz-places.3d417dcd.jpg";